import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryCreditPolicyModel } from '../../models/summary-credit-policy.model';


export enum CreditPolicyActionTypes {
  LoadCreditPolicies = '[CreditPolicy] Load CreditPolicies',
  LoadCreditPoliciesSuccess = '[CreditPolicy] Load CreditPolicies Success',
  LoadCreditPoliciesFailure = '[CreditPolicy] Load CreditPolicies Failure',

  LoadCreditPolicy = '[CreditPolicy] Load CreditPolicy',
  LoadCreditPolicySuccess = '[CreditPolicy] Load CreditPolicy Success',
  LoadCreditPolicyFailure = '[CreditPolicy] Load CreditPolicy Failure',

  CreateCreditPolicy = '[CreditPolicy] Create CreditPolicy',
  CreateCreditPolicySuccess = '[CreditPolicy] Create CreditPolicy Success',
  CreateCreditPolicyFailure = '[CreditPolicy] Create CreditPolicy Failure',

  UpdateCreditPolicy = '[CreditPolicy] Update CreditPolicy',
  UpdateCreditPolicySuccess = '[CreditPolicy] Update CreditPolicy Success',
  UpdateCreditPolicyFailure = '[CreditPolicy] Update CreditPolicy Failure',

  DeleteCreditPolicy = '[CreditPolicy] Delete CreditPolicy',
  DeleteCreditPolicySuccess = '[CreditPolicy] Delete CreditPolicy Success',
  DeleteCreditPolicyFailure = '[CreditPolicy] Delete CreditPolicy Failure',
}

/** Load all */

export class LoadCreditPolicies implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPolicies;
  constructor(public payload: {filter: any}) {}
}

export class LoadCreditPoliciesSuccess implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPoliciesSuccess;
  constructor(public payload: { items: SummaryCreditPolicyModel[]; total: number }) {}
}

export class LoadCreditPoliciesFailure implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPoliciesFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadCreditPolicy implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPolicy;
  constructor(public payload: { uid: string }) {}
}

export class LoadCreditPolicySuccess implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPolicySuccess;
  constructor(public payload: SingleResponseModel<SummaryCreditPolicyModel>) {}
}

export class LoadCreditPolicyFailure implements Action {
  readonly type = CreditPolicyActionTypes.LoadCreditPolicyFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateCreditPolicy implements Action {
  readonly type = CreditPolicyActionTypes.CreateCreditPolicy;
  constructor(public payload: { creditPolicy: SummaryCreditPolicyModel }) {}
}


export class CreateCreditPolicySuccess implements Action {
  readonly type = CreditPolicyActionTypes.CreateCreditPolicySuccess;
  constructor(public payload: { creditPolicy: SummaryCreditPolicyModel }) {}
}

export class CreateCreditPolicyFailure implements Action {
  readonly type = CreditPolicyActionTypes.CreateCreditPolicyFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateCreditPolicy implements Action {
  readonly type = CreditPolicyActionTypes.UpdateCreditPolicy;
  constructor(public payload: { creditPolicy: SummaryCreditPolicyModel }) {}
}

export class UpdateCreditPolicySuccess implements Action {
  readonly type = CreditPolicyActionTypes.UpdateCreditPolicySuccess;
  constructor(public payload: { creditPolicy: SummaryCreditPolicyModel }) {}
}

export class UpdateCreditPolicyFailure implements Action {
  readonly type = CreditPolicyActionTypes.UpdateCreditPolicyFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteCreditPolicy implements Action {
  readonly type = CreditPolicyActionTypes.DeleteCreditPolicy;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCreditPolicySuccess implements Action {
  readonly type = CreditPolicyActionTypes.DeleteCreditPolicySuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCreditPolicyFailure implements Action {
  readonly type = CreditPolicyActionTypes.DeleteCreditPolicyFailure;
  constructor(public payload: { error: any }) {}
}

export type CreditPolicyActions =
  | LoadCreditPolicies
  | LoadCreditPoliciesSuccess
  | LoadCreditPoliciesFailure
  | LoadCreditPolicy
  | LoadCreditPolicySuccess
  | LoadCreditPolicyFailure
  | CreateCreditPolicy
  | CreateCreditPolicySuccess
  | CreateCreditPolicyFailure
  | UpdateCreditPolicy
  | UpdateCreditPolicySuccess
  | UpdateCreditPolicyFailure
  | DeleteCreditPolicy
  | DeleteCreditPolicySuccess
  | DeleteCreditPolicyFailure
